import React, { useContext } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { OrderContext } from "./OrderScreen";
import { useEffect } from "react";
import { useState } from "react";
import { calculateBuyAmount } from "./OrderService";
import { roundToDecimals } from "../../helpers/FormatHelper";
import NumberInput from "../shared/NumberInput";
import { Alert } from "antd";
import AlertBox from "../shared/AlertBox";

const OrderSpreadModalForm = ({ updateSpreadModalForm }) => {

    const { showSpreadModal, setShowSpreadModal, rowCurrencyId, setRowCurrencyId, rowSpreadID, setRowSpreadID, rateStore, updateCurrencyRate, buySellSide,
        spreadUpdatedByUser, setSpreadUpdatedByUser, buyScaleCtx, timerIsRunning, setTimerIsRunning, spreadChangesAccepted
    } = useContext(OrderContext);

    const [amount, setAmount] = useState(0)
    const [costRate, setCostRate] = useState(1)
    const [customerRate, setCustomerRate] = useState(1);
    const [averageRate, setAverageRate] = useState(0);
    const [profit, setProfit] = useState(0)
    const [spreadPercentage, setSpreadPercentage] = useState(0);

    const [editingField, setEditingField] = useState('');

    //const rateInfo = rateStore?.get(rowCurrencyId);
    const rateInfo = rateStore?.get(rowSpreadID);

    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        if (!rateInfo) return;

        const costRate = Number(rateInfo.CostRate);
        const customerRate = Number(rateInfo.CustomerRate);
        const averageRate = Number(rateInfo.AverageRate);
        const profit = rateInfo.Profit

        const profitPoints = buySellSide.toLowerCase() === 'buy' ? costRate - customerRate : customerRate - costRate;

        const spread = rateInfo.SpreadPercentage ??
            (costRate !== 0
                ? ((profitPoints / costRate) * 100).toFixed(2)
                : 0);

        setAmount(Number(rateInfo.RowAmount))
        setCostRate(costRate)
        setCustomerRate(customerRate);
        setProfit(profit)
        setSpreadPercentage(spread);
        setAverageRate(averageRate);
    }, [rowSpreadID, rateInfo]);


    const onClose = () => {
       
        setRowCurrencyId("");
        setRowSpreadID(-1);
        if (!spreadChangesAccepted) {
            setTimerIsRunning(true)
        }
         setShowSpreadModal(false);
    };

    const getProfit = (amount, customerRate, costRate) => {
        const amountByRate = calculateBuyAmount(rateInfo.RateTerms, customerRate, buySellSide, amount, rateInfo.RatePrecision, false);
        const amountByCostRate = calculateBuyAmount(rateInfo.RateTerms, costRate, buySellSide, amount, rateInfo.RatePrecision, false);

        const profit = roundToDecimals(
            buySellSide.toLowerCase() === 'buy' ?
                (rateInfo.RateTerms === 'I' ? amountByRate - amountByCostRate : amountByCostRate - amountByRate) :
                (rateInfo.RateTerms === 'I' ? amountByCostRate - amountByRate : amountByRate - amountByCostRate),
            buyScaleCtx
        );
        return profit;
    }

    const getSpread = (customerRate, costRate) => {
        const profitPoints = buySellSide.toLowerCase() === 'buy' ?
            (rateInfo.RateTerms === 'I' ? costRate - customerRate : costRate - customerRate) :
            (rateInfo.RateTerms === 'I' ? customerRate - costRate : customerRate - costRate)
        return costRate !== 0
            ? ((profitPoints / costRate) * 100).toFixed(2)
            : 0;
    }

    const updateAmount = (e) => {

        if (editingField !== '') { return }

        if (!rateInfo) return;

        const newAmount = Number(e.target.value);
        setAmount(newAmount)

        setEditingField('amount')

        setProfit(getProfit(newAmount, customerRate, costRate))
        setSpreadPercentage(getSpread(customerRate, costRate));

        setEditingField('')
    }

    const updateCostRate = (e) => {

        if (editingField !== '') { return }

        if (!rateInfo) return;

        const newCostRate = Number(roundToDecimals(e.target.value, rateInfo.RatePrecision));
        setCostRate(newCostRate)

        setEditingField('costRate')

        setProfit(getProfit(amount, customerRate, newCostRate))
        setSpreadPercentage(getSpread(customerRate, newCostRate));

        setEditingField('')
    }

    const updateCustomerRate = (e) => {

        if (editingField !== '') { return }

        if (!rateInfo) return;

        const newCustomerRate = Number(roundToDecimals(e.target.value, rateInfo.RatePrecision));
        setCustomerRate(newCustomerRate);

        setEditingField('customerRate')

        setProfit(getProfit(amount, newCustomerRate, costRate))
        setSpreadPercentage(getSpread(newCustomerRate, costRate))

        setEditingField('')
    }

    const updateProfit = (e) => {

        if (editingField !== '') { return }

        if (!rateInfo) return;

        const newProfit = Number(e.target.value);
        setProfit(newProfit)

        setEditingField('profit')

        const amountByCostRate = calculateBuyAmount(rateInfo.RateTerms, costRate, buySellSide, amount, rateInfo.RatePrecision, false);

        //get customer Rate
        const isBuy = buySellSide.toLowerCase() === 'buy';
        const rateTermInverse = rateInfo.RateTerms === 'I';

        const amountByRate = isBuy ?
            (rateTermInverse ? amountByCostRate + newProfit : amountByCostRate - newProfit) :
            (rateTermInverse ? amountByCostRate - newProfit : amountByCostRate + newProfit)

        let customerRate;

        if (rateTermInverse) {
            customerRate = amount / amountByRate;
        } else {
            customerRate = amountByRate / amount;
        }

        const newCustomerRate = roundToDecimals(customerRate, rateInfo.RatePrecision);

        setCustomerRate(newCustomerRate)
        setSpreadPercentage(getSpread(newCustomerRate, costRate));

        setEditingField('')
    }

    const updateSpread = (e) => {

        if (editingField !== '') { return }

        if (!rateInfo) return;

        const newSpread = Number(e.target.value);
        setSpreadPercentage(newSpread);
        setEditingField('spread')

        const isBuy = buySellSide.toLowerCase() === 'buy';

        const spread = newSpread / 100;
        const multiplier = isBuy ?
            (rateInfo.RateTerms === 'I' ? 1 - spread : 1 - spread)
            : (rateInfo.RateTerms === 'I' ? 1 + spread : 1 + spread);

        const newCustomerRate = roundToDecimals(costRate * multiplier, rateInfo.RatePrecision);

        setCustomerRate(newCustomerRate);
        setProfit(getProfit(amount, newCustomerRate, costRate))

        setEditingField('')
    };

    const onAccept = () => {
        if (!rateInfo) return;

        if(profit < 0) {
            setShowAlert(true);
            return;
        }
        updateCurrencyRate(rowSpreadID, {
            RowAmount: amount,
            CostRate: costRate,
            CustomerRate: customerRate,
            Profit: profit,
            SpreadPercentage: spreadPercentage
        });

        updateSpreadModalForm(rowSpreadID);        
        setRowCurrencyId("");
        setRowSpreadID(-1);
        setSpreadUpdatedByUser(!spreadUpdatedByUser);
        setShowSpreadModal(false);

    };

    return (
        <Dialog open={showSpreadModal} onClose={onClose} maxWidth="xl"
        >
            <DialogTitle id="linktodeal-dialog-title">
                {rowCurrencyId
                    ? `Edit ${rowCurrencyId} Spread`
                    : "Edit Spread"}
            </DialogTitle>

            <DialogContent dividers style={{ paddingLeft: 15, paddingRight: 15, paddingTop: 0, paddingBottom: 5 }}>
                {rateInfo ? (
                    <>
                        <div className="uk-grid uk-margin uk-width-1-1">
                            <div className="uk-width-1-3" >
                                <div className="uk-margin">
                                    <label className="uk-form-label" htmlFor="bn-spread-buy-amount">Amount</label>
                                    <div>
                                        <NumberInput id="bn-spread-buy-amount" key="bn-spread-buy-amount" className="uk-input" value={amount}
                                            scale={2} type="Currency"
                                            onChange={updateAmount} />
                                    </div>
                                </div>
                            </div>
                            <div className="uk-width-1-3" >
                                <div className="uk-margin">
                                    <label className="uk-form-label" htmlFor="bn-spread-cost-rate">Market Rate</label>
                                    <div>
                                        <NumberInput id="bn-spread-cost-rate" key="bbn-spread-cost-rate" className="uk-input" value={costRate}
                                            scale={rateInfo.RatePrecision} type="Rate"
                                            onChange={updateCostRate} />
                                    </div>
                                </div>
                            </div>
                            <div className="uk-width-1-3" >
                                <div className="uk-margin">
                                    <label className="uk-form-label" htmlFor="bn-spread-customer-rate">Customer Rate</label>
                                    <div>
                                        <NumberInput id="bn-spread-customer-rate" key="bn-spread-customer-rate" className="uk-input" value={customerRate}
                                            scale={rateInfo.RatePrecision} type="Rate"
                                            onChange={updateCustomerRate} />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="uk-grid uk-margin uk-width-1-1">
                            <div className="uk-width-1-3" >
                                <div className="uk-margin">
                                    <label className="uk-form-label" htmlFor="bn-spread-profit-amount">Profit amount</label>
                                    <div>
                                        <NumberInput id="bn-spread-profit-amount" key="bn-spread-profit-amount" className="uk-input" value={profit}
                                            scale={2} type="Rate"
                                            onChange={updateProfit} negative={true} />
                                    </div>
                                </div>
                            </div>
                            <div className="uk-width-1-3" >
                                <div className="uk-margin">
                                    <label className="uk-form-label" htmlFor="bn-spread-percentage">Spread(%)</label>
                                    <div>
                                        <NumberInput id="bn-spread-percentage" key="bn-spread-percentage" className="uk-input" value={spreadPercentage}
                                            scale={2} type="Rate"
                                            onChange={updateSpread} negative={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="uk-width-1-3" >
                                <div className="uk-margin">
                                    <label className="uk-form-label" htmlFor="bn-spread-customer-rate">Average Rate</label>
                                    <div>
                                        <NumberInput id="bn-spread-customer-rate" key="bn-spread-customer-rate" className="uk-input" value={averageRate}
                                            scale={rateInfo.RatePrecision} type="Rate" disabled={true} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    
                    <div className="uk-grid">

                        <div className="uk-width-1-1" style={{ textAlign: 'center', margin: '20px'}}>
                            No Rate Info Found
                        </div>
                    </div>
                )}

                <AlertBox open={showAlert} onClose={() => setShowAlert(false)} title={'Error'} message={'Review amounts'} type="Ok" okClick={() => setShowAlert(false)} />
            </DialogContent>

            <DialogActions style={{ padding: '4px' }}>

                {rateInfo ? (<>
                <button className="uk-button uk-button-green" onClick={onAccept} >
                    Accept
                </button>

                <button className="uk-button uk-button-green" onClick={onClose}>
                    Close
                </button>
                </>) : (
                    <button className="uk-button uk-button-green" onClick={onClose}>
                        Ok
                    </button>
                )}
            </DialogActions>
        </Dialog>
        
    );
};

export default OrderSpreadModalForm